import { useEffect, useState, useRef } from 'react';
import './Header.scss';
import About from '../About/About';
import ContactLinks from '../ContactLinks/ContactLinks';

export default function Header() {
    const [isAnimating, setIsAnimating] = useState(false);
    const [isAnimating2, setIsAnimating2] = useState(false);
    const [isVideoHidden, setIsVideoHidden] = useState(false);
    const videoRef = useRef(null);
    const text = '< Full Stack Developer />';

    useEffect(() => {
        setIsAnimating(true);
        setTimeout(() => {
            setIsAnimating2(true);
            if (videoRef.current) {
                videoRef.current.currentTime = 0;
                videoRef.current.playbackRate = 2;
                videoRef.current.play().catch(error => {
                    console.error('Error playing video:', error);
                    setIsVideoHidden(true);
                });
            }
        }, 750);
    }, []);

    return (
        <div id="main" className='header-container'>
            <h1 className={isAnimating ? 'title animate' : 'title'}>
                <span className="title-letter">Y</span>
                <span className="title-letter">a</span>
                <span className="title-letter">r</span>
                <span className="title-letter">d</span>
                <span className="title-letter">e</span>
                <span className="title-letter">n</span>
                <span className="title-space">&nbsp; </span>
                <br className="title-break" />
                <span className="title-letter">A</span>
                <span className="title-letter">m</span>
                <span className="title-letter">i</span>
                <span className="title-letter">r</span>
            </h1>
            {/* <h3>&lt; Full Stack Developer /&gt;</h3> */}
            <div className="subtitle-container">
                <h3 className={isAnimating2 ? 'subtitle animate' : 'subtitle'}>
                    {text}
                </h3>
            </div>
            <About />
            <ContactLinks />
        </div>
    );
}

